/*******************
 * User preferences
 *******************/

import type { IUserPreferences } from '~/types/user-preference'

import config from '~/config'
import { request } from '~/utils/request'

/**
 * Get the user preferences
 * @doc https://toolbox-prod-europe-west9-6xd26izywq-od.a.run.app/#get-/user-preferences
 */
export const getUserPreferences = (): Promise<IUserPreferences> => {
  return request({
    url: `${config.TOOLBOX_API}/user-preferences`,
  })
}

/**
 * Create or update user preferences
 * @doc https://toolbox-prod-europe-west9-6xd26izywq-od.a.run.app/#post-/user-preferences
 */
export const updateUserPreferences = (data: IUserPreferences): Promise<IUserPreferences> => {
  return request({
    data,
    method: 'POST',
    url: `${config.TOOLBOX_API}/user-preferences`,
  })
}
